/**
 * The plans a company can be on (LB-6228) and what each includes, for the tier badge's info tip (PRD V3, FR-11).
 * The wording is PRD V3's proposal and is still to agree with Haley (Q17), so it lives here and nowhere else.
 */
export const SUBSCRIPTION_TIERS = {
  Pro: {
    name: 'Pro',
    tip: 'Upload one bill at a time while billing a utility in Property allocation, and Livable reads it for you. Your bills show on the Bills page; uploading there, and email-in, come with Plus.'
  },
  Plus: {
    name: 'Plus',
    tip: "Email bills to your company's intake address, or upload many at once on the Bills page. Livable reads each bill, and your team allocates and approves. Applies to all your properties."
  },
  Autopilot: {
    name: 'Autopilot',
    tip: 'Everything in Plus. Livable also fetches bills from your utility portals and does the allocation and approvals for you. Applies to all your properties.'
  }
};

/** The tier the route named, or null for anything else: a name this screen doesn't know shows no badge. */
export const tierOf = name => Object.prototype.hasOwnProperty.call(SUBSCRIPTION_TIERS, name) ? SUBSCRIPTION_TIERS[name] : null;

/** Why a push isn't offered on a plan without AP Push, in the words bill-automation refuses one with (LB-6188). */
export const AP_PUSH_NEEDS_PLAN_REASON = 'AP Push needs Plus or Autopilot.';

/**
 * Whether the company's plan, `{ tier, allows }`, holds a push back: AP Push is an add-on for Plus and Autopilot
 * (FR-28). Only a plan that's known and says no. While it's unknown, or with billing options off (the hook answers null
 * then), the push is offered as before and the server decides.
 */
export const apPushNeedsPlan = plan => {
  var _plan$allows;
  return (plan === null || plan === void 0 || (_plan$allows = plan.allows) === null || _plan$allows === void 0 ? void 0 : _plan$allows.apPush) === false;
};